import React, { useEffect, useState } from 'react';

/** MissionTimer — live mission-clock showing countdown to the goal ETA, or "T+" since mission start. */
export const MissionTimer = ({ etaIso, startIso, label = 'Mission T-' }) => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, []);

  const now = Date.now();
  // If we have a future ETA, show countdown; else show elapsed since startIso (or signal 'computing').
  const target = etaIso ? new Date(etaIso).getTime() : null;
  const start = startIso ? new Date(startIso).getTime() : null;

  let seconds = 0;
  let direction = 'T-';
  if (target && target > now) {
    seconds = Math.floor((target - now) / 1000);
    direction = 'T-';
  } else if (start) {
    seconds = Math.floor((now - start) / 1000);
    direction = 'T+';
  } else {
    // No signal yet — show a placeholder running clock
    seconds = Math.floor(tick);
    direction = 'T+';
  }

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const pad = (n) => String(n).padStart(2, '0');

  return (
    <div className="flex items-center gap-3">
      <div className="text-[10px] uppercase tracking-widest text-white/45 mono">{label}{direction}</div>
      <div className="flex items-center gap-1 mono tabular-nums">
        <TimeChip v={days} unit="d" />
        <TimeChip v={pad(hours)} unit="h" />
        <TimeChip v={pad(mins)} unit="m" />
        <TimeChip v={pad(secs)} unit="s" accent />
      </div>
    </div>
  );
};

const TimeChip = ({ v, unit, accent }) => (
  <span className="inline-flex items-baseline gap-0.5 px-1.5 py-0.5 rounded-md hairline bg-white/[0.03]">
    <span className={`text-sm font-semibold ${accent ? 'text-[#39FF14]' : 'text-white/92'}`}>{v}</span>
    <span className="text-[9px] text-white/40">{unit}</span>
  </span>
);

export default MissionTimer;
